import auth from '../../services/auth';
import messageDialog from '../../components/message-dialog.vue';
import refund from '../../services/refund-service';
import Pagination,{ Page } from '../../components/pagination';
import Account from '../../services/account';
import { removeMascara } from '../../filters/string';

export default {
  data() {
    return {
    filter: {
        occurrenceDate: undefined,
        plate: undefined,
        taxPayerIdNumber: auth.currentUser.taxIdNumber
        },
      occurrenceDate: undefined,
      loading: false,
      refunds: [],
      refundSelected: undefined,
      refundPassageHist: undefined,
      page: new Page(1),
      name: undefined,
      dataEstorno: undefined,
      dataCancelaEstorno: undefined
    }
  },
  methods: {
    searchRefunds() {
        if(!this.filter.plate || !this.occurrenceDate) {
          return messageDialog.show({
            title: "Aviso",
            headerClass: "modal-info",
            message: "Favor fornecer uma placa e uma data para a consulta"
        });
        }
        var date = new Date(this.occurrenceDate),
        mnth = ("0" + (date.getMonth()+1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
        this.filter.occurrenceDate = [date.getFullYear(), mnth, day].join("-");
        this.filter.plate = this.filter.plate.replace(/-/g, "");
        this.loading = refund
          .getRefundPassage(this.filter)
          .then(x => {
            let resp = x.response || x;
            if (resp.status.code != 0) {
              return Promise.reject(resp);
            }
            if (resp.refundPassages.length > 0) {
              this.refunds = resp.refundPassages;
            } else {
                this.refunds = [];
                messageDialog.show({
                    title: "Aviso",
                    headerClass: "modal-info",
                    message: "Nenhuma contestação localizada."
                });
            }
          }).catch(error => console.error(error));
      },
    getRefundDetails(refundPassage) {
        this.loading = refund.getRefundPassageHist(refundPassage.refundPassageId).then(resp => {
          this.refundSelected = refundPassage;
          this.refundPassageHist = resp.response;
          this.findUserData();
        }).catch(err => {
          messageDialog.show({
            title: "Aviso",
            headerClass: "modal-danger",
            message: "Ocorreu um erro ao recuperar os detalhes da contestação."
          });
          console.error(err);
        });

        this.loading = refund.getRefusedDebit(refundPassage.transactionId).then(resp => {
          let debito = resp.BiAccountStatement;
          let estorno = _.filter(debito, (o) => {
            return o.idHistoric == 1327;
          });
          estorno = estorno.sort((a, b) => new Date(b.processingDate) - new Date(a.processingDate));
          this.dataEstorno = estorno[0].processingDate;

          let canc = _.filter(debito, (o) => {
            return o.idHistoric == 2327;
          });

          canc = canc.sort((a, b) => new Date(b.processingDate) - new Date(a.processingDate));
          this.dataCancelaEstorno = canc[0].processingDate;
        });
      },
      findUserData() {
        this.loading = Account.getUserAndAddressByTaxIdNumber(removeMascara(this.refundSelected.taxPayerIdNumber)).then(resp => {
          if(resp.status.code == 0) {
            this.name = resp.user.person ? resp.user.person.name + ' ' + resp.user.person.lastName : resp.user.company.companyName;
          } else {
            this.name = "";
          }
          $("#refundDetails").modal("show");
        }).catch(err => {
          
        });
      },
  },
  computed: {
    hasComments() { //verifica se existem comentários da MM e da concessionária
      return this.refundPassageHist && this.refundPassageHist.some(r => r.comments && r.userType == 2);
    },
    hasFiles() {
      return this.refundPassageHist && this.refundPassageHist.some(r => !r.comments);
    },
    hasRefusedDebit() {
      return this.refundPassageHist && this.refundPassageHist.some(r => r.comments && r.status == 4);
    },
  },
  components: {
    Pagination
  }
}


// WEBPACK FOOTER //
// ./src/pages/account/refund.js